import React, { useState } from "react";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  CkEditor,
  Select,
  CheckBox,
  PersianDataPicker,
  TextArea,
} from "components/form";
import { required, validationWrapper } from "lib/formValidations";
import {
  dateTimeToserver,
  generate_uuid,
  transformTranslateFromValues,
} from "lib/helpers";
import Modal from "components/Modal";
import { useCore } from "store/core";
import axios from "axios";

// components

export default function Add(props) {
  const [prices, setPrices] = useState([]);
  const [showAddPrice, setShowAddPrice] = useState(false);
  const core = useCore();
  const [trailers, setTrailers] = useState([]);
  const [showAddTrailer, setShowAddTrailer] = useState(false);
  const _renderTrailers = () => {
    return trailers.map((item) => (
      <div className="grid grid-cols-5 gap-3">
        <h5>{item.language === "en" ? "انگلیسی" : "فارسی"}</h5>
        <h5 className="col-span-3 text-left">{item.source}</h5>
        <div className="flex justify-center items-center">
          <button
            type="button"
            onClick={() => {
              setTrailers(trailers.filter((i) => i.uuid != item.uuid));
            }}
            className="btn btn-sm btn-danger"
          >
            حذف
          </button>
        </div>
      </div>
    ));
  };
  const _renderPrices = () => {
    return prices.map((item) => (
      <div className="grid grid-cols-4 gap-2">
        <h5>{item.currency === "USD" ? "دلار" : "تومان"}</h5>
        <h5 className="text-center">{item.amount}</h5>
        <h5 className="text-center">
          <button
            type="button"
            className={`btn btn-sm ${
              item.status ? "btn-success" : "btn-danger"
            }`}
            onClick={() => {
              setPrices([
                ...prices.filter((i) => i.uuid !== item.uuid),
                { ...item, status: !item.status },
              ]);
            }}
          >
            {item.status ? "فعال" : "غیر فعال"}
          </button>
        </h5>
        <div className="flex justify-center items-center">
          <button
            type="button"
            onClick={() => {
              setPrices(prices.filter((i) => i.uuid != item.uuid));
            }}
            className="btn btn-sm btn-danger"
          >
            حذف
          </button>
        </div>
      </div>
    ));
  };

  return (
    <>
      <AddPrices
        close={() => setShowAddPrice(false)}
        show={showAddPrice}
        submit={(values) => {
          setPrices([...prices, values]);
        }}
      />
      <AddTrailer
        close={() => setShowAddTrailer(false)}
        show={showAddTrailer}
        submit={(values) => {
          setTrailers([...trailers, values]);
        }}
      />
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{}}
          onSubmit={async (values, { setSubmitting }) => {
            if (values.live_start_at) {
              values.live_start_at = dateTimeToserver(values.live_start_at);
            }

            await props.submit({
              ...transformTranslateFromValues(values),
              prices,
              trailers: trailers.map((i) => ({
                language: i.language,
                source: i.source,
              })),
            });
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty, values }) => (
            <Form>
              <div className="modal-body py-1 gap-y-3">
                <div className="intro-x md:grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="عنوان"
                    label="عنوان :"
                    name="title"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                  <Field
                    placeholder="عنوان انگلیسی"
                    label="عنوان انگلیسی :"
                    name="_en*title*text"
                    component={TextField}
                  />
                  <Field
                    placeholder="توضیحات"
                    label="توضیحات :"
                    name="desc"
                    component={TextArea}
                    validate={(value) => validationWrapper(value, required)}
                  />
                  <Field
                    placeholder="توضیحات انگلیسی"
                    label="توضیحات انگلیسی :"
                    name="_en*desc*text"
                    component={TextArea}
                  />
                  <div className="col-span-2 md:grid md:grid-cols-3 md:gap-3">
                    <div>
                      {core.slidersLoad ? (
                        <Loading />
                      ) : (
                        <Field
                          label="اسلایدر :"
                          name="slider_id"
                          valueOnly
                          component={Select}
                          options={core.sliders || []}
                        />
                      )}
                    </div>
                    <div>
                      {core.menusLoad ? (
                        <Loading />
                      ) : (
                        <Field
                          label="منو :"
                          name="menu_id"
                          valueOnly
                          component={Select}
                          options={core.menus || []}
                        />
                      )}
                    </div>
                    <Field
                      label="شروع از :"
                      name="live_start_at"
                      component={PersianDataPicker}
                      format="YYYY/MM/DD HH:mm:ss"
                      hasTime={true}
                      validate={(value) => validationWrapper(value, required)}
                    />
                  </div>
                  <div className="col-span-2 md:grid md:grid-cols-2 md:gap-2">
                    <div>
                      <Field
                        label="درایور :"
                        name="driver_type"
                        valueOnly
                        component={Select}
                        options={[
                          { value: "HashureLive", label: "لایو vod" },
                          {
                            value: "HashureLiveStream",
                            label: "لایو استریم vod",
                          },
                        ]}
                        validate={(value) => validationWrapper(value, required)}
                      />
                    </div>
                    {values.driver_type == "HashureLive" && (
                      <Field
                        label="لینک :"
                        name="driver_source"
                        valueOnly
                        component={TextField}
                        validate={(value) => validationWrapper(value, required)}
                      />
                    )}
                  </div>
                  <div className="col-span-2 md:grid md:grid-cols-2 md:gap-2">
                    <div>
                      <Field
                        label="دسترسی :"
                        name="access"
                        valueOnly
                        component={Select}
                        options={[
                          { value: "FREE", label: "رایگان" },
                          { value: "TICKET", label: "بلیت" },
                        ]}
                        validate={(value) => validationWrapper(value, required)}
                      />
                    </div>
                  </div>
                  {values.access == "TICKET" && (
                    <div className="intro-y col-span-2 border rounded p-2 border-theme-21">
                      <div className="flex justify-between items-center">
                        <h2>قیمت ها :</h2>
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={() => setShowAddPrice(true)}
                        >
                          افزودن قیمت
                        </button>
                      </div>
                      <hr className="my-2" />
                      <div className="grid grid-cols-1 gap-4 mt-3">
                        <div className="grid grid-cols-4 gap-2">
                          <h5>واحد پولی</h5>
                          <h5 className="text-center">مقدار</h5>
                          <h5 className="text-center">وضعیت</h5>
                          <div className="flex justify-center items-center">
                            عملیات
                          </div>
                        </div>
                        {_renderPrices()}
                      </div>
                    </div>
                  )}
                  <div className="intro-y col-span-2 border rounded p-2 border-theme-21">
                    <div className="flex justify-between items-center">
                      <h2>تریلر ها :</h2>
                      <button
                        className="btn btn-sm btn-primary"
                        type="button"
                        onClick={() => setShowAddTrailer(true)}
                      >
                        افزودن تریلر
                      </button>
                    </div>
                    <hr className="my-2" />
                    <div className="grid grid-cols-1 gap-4 mt-3">
                      <div className="grid grid-cols-5 gap-3">
                        <h5>زبان</h5>
                        <h5 className="col-span-3 text-center">لینک فایل</h5>
                        <div className="flex justify-center items-center">
                          عملیات
                        </div>
                      </div>
                      {_renderTrailers()}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1 text-white"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}

export function AddPrices(props) {
  return (
    <Modal
      zIndex={1000}
      show={props.show}
      handleClose={props.close}
      title="افزودن قیمت"
    >
      <Formik
        key="fromik_p_price"
        initialValues={{ uuid: generate_uuid() }}
        onSubmit={(values, { setSubmitting }) => {
          props.submit(values);
          props.close();
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, handleSubmit }) => (
          <Form>
            <div className="modal-body gap-y-3">
              <div className="intro-x grid md:grid-cols-4 md:gap-3">
                <div></div>
                <div className="">
                  <Field
                    placeholder="واحد پولی"
                    label="واحد پولی :"
                    name="currency"
                    component={Select}
                    options={[
                      { value: "IRR", label: "تومان" },
                      { value: "USD", label: "دلار" },
                    ]}
                    validate={(value) => validationWrapper(value, required)}
                  />
                </div>
                <div className="">
                  <Field
                    placeholder="مقدار"
                    label="مقدار :"
                    name="amount"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                </div>
                <div className="">
                  <Field label="فعال؟" name="status" component={CheckBox} />
                </div>
              </div>
            </div>
            <div className="modal-footer text-right">
              <button
                className="btn btn-primary w-20"
                type="button"
                onClick={handleSubmit}
                disabled={!!(isSubmitting || !dirty)}
              >
                {isSubmitting ? <Loading /> : "ذخیره"}
              </button>
              <button
                type="button"
                disabled={isSubmitting}
                onClick={props.close}
                className="btn btn-outline-secondary w-20 mr-1 text-white"
              >
                انصراف
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export function AddTrailer(props) {
  return (
    <Modal
      show={props.show}
      handleClose={props.close}
      title="افزودن تریلر"
      zIndex={1024}
    >
      <Formik
        key="fromik_p_trailer"
        initialValues={{ uuid: generate_uuid() }}
        onSubmit={(values, { setSubmitting }) => {
          props.submit(values);
          props.close();
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, handleSubmit, values, setFieldValue }) => (
          <Form>
            <div className="modal-body gap-y-3">
              <div className="intro-x grid md:grid-cols-3 md:gap-3">
                <div className="col-span-2">
                  <Field
                    placeholder="تبدیل ایدی به لینک تریلر"
                    label="ایدی تریلر :"
                    name="source_id"
                    component={TextField}
                  />
                </div>
                <div className="col-span-1">
                  <button
                    className="btn btn-primary w-36 h-10 mt-6"
                    type="button"
                    onClick={async () => {
                      if (values.source_id) {
                        try {
                          const result = await axios.get(
                            `https://streaming.payamariana.ir/getvideobyid.php?id=${values.source_id}`
                          );
                          setFieldValue("source", result.data);
                        } catch (e) {
                          setFieldValue("source", "");
                        }
                      }
                    }}
                  >
                    تولید لینک
                  </button>
                </div>
              </div>
              <div className="intro-x grid md:grid-cols-3 md:gap-3">
                <div className="col-span-1">
                  <Field
                    placeholder="زبان تریلر"
                    label="زبان تریلر :"
                    name="language"
                    component={Select}
                    options={[
                      { value: "fa", label: "فارسی" },
                      { value: "en", label: "انگلیسی" },
                    ]}
                    validate={(value) => validationWrapper(value, required)}
                  />
                </div>
                <div className="col-span-2">
                  <Field
                    placeholder="لینک تریلر"
                    label="لینک تریلر :"
                    name="source"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer text-right">
              <button
                className="btn btn-primary w-20"
                type="button"
                onClick={handleSubmit}
                disabled={!!(isSubmitting || !dirty)}
              >
                {" "}
                {isSubmitting ? <Loading /> : "ذخیره"}
              </button>
              <button
                type="button"
                disabled={isSubmitting}
                onClick={props.close}
                className="btn btn-outline-secondary w-20 mr-1 text-white"
              >
                انصراف
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
